import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer id="footer" className="footer dark-background">

      <div className="container footer-top">
        <div className="row gy-4">

          {/* About */}
          <div className="col-lg-4 col-md-6 footer-about text-white justify-content-center">
            <h4>Mahawar Samaaj</h4>

            <div className="footer-contact pt-3">
              <p>Rewari, Haryana, India</p>
              <p className="mt-3"><strong>Phone:</strong> <span>9416287746</span></p>
              <p><strong>Email:</strong> <span>mvsrwr@gmail.com</span></p>
              <p><strong>Reg No.:</strong> <span>HR/RWR/2014/00309</span></p>
            </div>
          </div>

          {/* Useful Links */}
          <div className="col-6 col-md-3 col-lg-2 footer-links">
            <h4>Useful Links</h4>
            <ul>
              <li><Link to="/#about">About Us</Link></li>
              <li><Link to="/#team">Team</Link></li>
              <li><Link to="/activity">Activities</Link></li>
              <li><Link to="/gallery">Gallery</Link></li>
              <li><Link to="/member-list">Member List</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>

          {/* Our Activities */}
          <div className="col-6 col-md-3 col-lg-2 footer-links">
            <h4>Our Activities</h4>
            <ul>
              <li><a href="#services">Social Welfare</a></li>
              <li><a href="#services">Education Support</a></li>
              <li><a href="#services">Health Camps</a></li>
              <li><a href="#services">Community Events</a></li>
              <li><a href="#services">Charity Programs</a></li>
            </ul>
          </div>

          {/* Location Map */}
          <div className="col-lg-4 col-md-12 footer-newsletter">
            <h4>Our Location</h4>
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3516.8594736668997!2d76.62624307548442!3d28.181188875914195!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d50174fa818a3%3A0x855a0d1062872d95!2sMahawar%20Palace!5e0!3m2!1sen!2sin!4v1777085046120!5m2!1sen!2sin"
              width="100%"
              height="200"
              style={{ border: 0, borderRadius: '10px' }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade">
            </iframe>
          </div>

        </div>
      </div>

      {/* Copyright */}
      <div className="container copyright text-center mt-4">
        <div className="social-links d-flex justify-content-center mt-4 mb-4 ">
          <a href="mailto:mvsrwr@gmail.com"><i class="bi bi-envelope"></i></a>
          <a href="tel:9416287746"><i class="bi bi-phone"></i></a>
          <a href="https://wa.me/919416287746" target="_blank" ><i className="bi bi-whatsapp"></i></a>
        </div>
        <p>© <span>Copyright </span>
          <strong className="px-1 sitename"> Mahawar Samaaj</strong>
          <span>All Rights Reserved</span>
        </p>

        <div className="credits">
          Designed & Developed by
          <a href="https://www.whitecollarinfotech.com/" target="_blank" rel="noopener noreferrer">
            <strong> White Collar Infotech</strong>
          </a>
        </div>
      </div>

    </footer>
  );
}

export default Footer;
